import { render, staticRenderFns } from "./v-icon-sprites.vue?vue&type=template&id=24ef202b&"
import script from "./v-icon-sprites.vue?vue&type=script&lang=js&"
export * from "./v-icon-sprites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports